import { createUseStyles } from 'react-jss'
import { facebookBlue, lightGrey } from '../../../../../../styles/const/colors'
import { transitionShort } from '../../../../../../styles/const/common'
import { textEllipsis } from '../../../../../../styles/mixins/text'

const useStyles = createUseStyles({
  campaignName: {
    fontSize: '14px !important',
    fontWeight: 700,
    display: 'flex',
    alignItems: 'center',
    minHeight: 30,
    position: 'relative',
    marginLeft: 65,
    paddingTop: 20,
    paddingBottom: 5
  },
  providerIcon: {
    position: 'absolute',
    left: -45
  },
  nameCell: {
    paddingLeft: 40
  },
  lineItemNameContainer: {
    width: '100%',
    display: 'flex',
    alignItems: 'flex-end'
  },
  lineItemNameLink: {
    width: '100%',
    fontSize: 14,
    fontWeight: 400,
    display: 'flex',
    textDecoration: 'none',
    color: '#000',
    transition: transitionShort,
    cursor: 'pointer',
    '&.linkTouched, &:hover, &:active': {
      color: facebookBlue
    }
  },
  lineItemName: {
    marginLeft: 8,
    ...textEllipsis()
  },
  downRightIcon: {
    minWidth: 18,
    color: lightGrey
  }
})

export default useStyles
